import type { Messages } from "@prop/i18n";
import type en from "../en/breach";

export default {
  eyebrow: "Cuenta detenida",
  title: "La cuenta está detenida: se perdió el límite",
  lead: "Se infringió una regla del programa, así que el trading en esta cuenta terminó. Las órdenes abiertas se cancelaron y todas las posiciones se cerraron a mercado.",
  rules: {
    max_loss: "Pérdida máxima: el equity cayó al piso de la cuenta",
    daily_loss: "Pérdida diaria: el equity cayó por debajo del límite de hoy",
    max_trade_loss: "Pérdida por operación: una sola operación perdió más de lo permitido",
    consistency: "Consistencia: un solo día generó una parte demasiado grande de la ganancia",
    max_duration: "Se acabó el tiempo: la fase pasó de su último día",
    inactivity: "Inactividad: demasiado tiempo sin operar",
    max_trading_days: "Se agotaron los días de trading antes del objetivo",
  },
  limit: "Límite",
  observed: "Al incumplir",
  days: { one: "{count} día", other: "{count} días" },
  at: "Cuándo",
  result: "Resultado final",
  balance: "Balance {balance} de {start}",
  closedTitle: "Se cerraron todas las posiciones",
  closedNone: "No había posiciones abiertas.",
  closing: "Cerrando las posiciones…",
  long: "Largo",
  short: "Corto",
  next: "Qué sigue",
  reset: {
    title: "Reinicia por {price}",
    note: "El {pct} % de los {base} que costó la cuenta. La misma cuenta desde el inicio: mismas reglas, mismo tamaño.",
    noteFixed: "La misma cuenta desde el inicio: mismas reglas, mismo tamaño.",
    confirm: "Pagar {price} y reiniciar",
  },
  coupon: {
    title: "Nueva cuenta con −{pct} %",
    note: "Tu cupón personal para la próxima compra. Válido hasta el {date}, una sola vez.",
    copy: "Copiar",
    copied: "Copiado",
    go: "Elegir una cuenta",
    used: "Este cupón ya se usó.",
  },
  free: {
    title: "Usa el reinicio gratis",
    note: "Venía con tu compra. Activación: {fee}.",
    noteFree: "Venía con tu compra.",
    confirm: "Pagar {fee} y reiniciar",
    confirmFree: "Reiniciar gratis",
  },
  back: "Volver",
  close: "Cerrar",
  history: "Ir al historial",
  more: { one: "Se detuvo {count} cuenta más: está en el historial.", other: "Se detuvieron {count} cuentas más: están en el historial." },
  reasons: {
    already_restarted: "Esta cuenta ya se reinició.",
    not_failed: "Solo se puede reiniciar una cuenta detenida.",
    reset_fee_due: "El pago del reinicio aún no está disponible. Escribe a soporte.",
    bonus_activation_due: "El pago de la activación aún no está disponible. Escribe a soporte.",
    no_reset_fee: "Este programa no tiene reinicio de pago.",
  },
  log: {
    title: "Historial",
    lead: "Cuentas detenidas, superadas y cerradas, y cómo terminó cada una.",
    rule: "Regla: {rule}",
    result: "Resultado",
    details: "Detalles",
    open: "Abrir",
  },
} satisfies Messages<typeof en>;
